import CircularProgress from "@mui/material/CircularProgress";
import {useHistory,useLocation} from 'react-router-dom'
import { useEffect } from "react";
import BaseUrl from "../BaseUrl";
import axios from "axios";
export default function CalendlyLoad(props){
    const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"))
    const locData=useLocation()
    const history = useHistory();
    useEffect(() => {
      axios
        .post(`https://calendly.com/oauth/token?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&client_secret=QP2iUiADJkDBQzFudVSdKU_llhekpna7sNZ73lLgqRQ&${locData.search.replace('?','')}&grant_type=authorization_code&redirect_uri=https://app.coldsender.com/Calendly-verify/`)
        .then((res) => {
          if (res.data) {
            let accData={
                calendlyCode:locData.search.replace('?',''),
                calendlyRefreshToken:res.data.refresh_token,
                calendlyAccessToken:res.data.access_token,
                calendlyOwner:res.data.owner,
                calendlyOrganization:res.data.organization
            }
            axios
            .put(
              `${
                BaseUrl.baseurl
              }/email-marketing/user/update-user-calendly-details/${
                userDetails && userDetails.details._id
              }`,
              accData,
              {
                headers: {
                  Authorization: `Bearear ${userDetails && userDetails.token}`,
                },
              }
            )
            .then((response) => {
              if (response.data.status) {
                history.push('/Email/accounts')
              } else {
                if (response.data.tokenExpire) {
                  localStorage.removeItem("MailSenderuserDetails");
                  window.location.reload();
                }
              }
            })
            .catch((err) => console.log("Error"));
          }
        })
        .catch((err) => console.log("Error"));
    }, []);
    return(
        <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress
        size={60}
        style={{
          color: "#1C485F",
        }}
      />
    </div>
    )
}